import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAC_AcknowledgementById = createAsyncThunk(
  "Acknowledgement/GetAC_AcknowledgementById",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Acknowledgement/GetAC_AcknowledgementById",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Acknowledgement = createSlice({
  name: "Acknowledgement",
  initialState: {
    Acknowledgement: [],
    loadingAcknowledgement: false,
    errorAcknowledgement: null,
  },
  reducers: {
    SetAcknowledgement: (state, action) => {
      state.Acknowledgement = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAC_AcknowledgementById.pending, (state, action) => {
        state.loadingAcknowledgement = true;
        state.Acknowledgement = action.payload;
        state.errorAcknowledgement = null;
      })
      .addCase(GetAC_AcknowledgementById.fulfilled, (state, action) => {
        state.loadingAcknowledgement = false;
        state.Acknowledgement = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAC_AcknowledgementById.rejected, (state, action) => {
        state.loadingAcknowledgement = false;
        state.errorAcknowledgement = action.payload;
      });
  },
});
export const { SetAcknowledgement } = Acknowledgement.actions;

export default Acknowledgement.reducer;
